export default __webpack_public_path__ + "static/media/section3-pic2.c4f02418.png";